export const HTTP_STATUS_CODE = {
    BAD_REQUEST: 400,
    NOT_FOUND: 404,
    CONFLICT: 409,
};
